import type { TFunction } from 'i18next';

/**
 * The kinds of shopping lists offered when a list is created (user 2026-09-30: "Drogerie,
 * Lebensmittel, Diverses, konfigurierbar"): the user's own types from the shopping preferences,
 * else the app's defaults in the user's language.
 */
export function listTypeOptions(configured: string[], t: TFunction): string[] {
  if (configured.length) return configured;
  return t('shopping.types.defaults')
    .split(',')
    .map((x) => x.trim())
    .filter(Boolean);
}
